export default "__VITE_ASSET__DAc2yPuj__"